import { render } from "./PostEditListView.vue?vue&type=template&id=349b5c1d"
import script from "./PostEditListView.vue?vue&type=script&lang=js"
export * from "./PostEditListView.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__